import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";
import {DropDownItem} from "../../../../../modals/types/dropdown";
import "./tab0.scss";
import {RadioButton} from "../../../../../modals/types/radiobutton";
import * as React from "react";
import {useState} from "react";
import RadioButtons from "../../../../../ui/radiobutton/radiobutton";
import Dropdown from "../../../../../ui/dropdown/dropdown";
import SingleSelectDropzone from "../../../../../ui/dropzone/singleselect/singleSelectDropzone";
import Matchingadtemplate from "../../../../../ui/adtemplate/matchingadtemplate/matchingadtemplate";

const Tab0 = () => {
    const [type, setType] = useState('C');
    const [gender, setGender] = React.useState('F');
    const typeRadioContent: RadioButton[] = [
        {label: "عادی", currentValue: "C"},
        {label: "هدفمند", currentValue: "G"},
    ]
    const adTypeDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"}
    ];
    const categoryDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"}
    ];
    const genderRadioContent: RadioButton[] = [
        {label: "خانم", currentValue: "F"},
        {label: "آقا", currentValue: "M"},
    ]
    const setRadioContent = (value: string): JSX.Element => {
        if (value === "C") {
            return (
                <>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <label htmlFor="campaignName">عنوان کمپین</label>
                            <input type="text" name="campaignName" id="campaignName" className="Campaign-Input mt-2"
                                   placeholder="مثال: کمپین روز مادر"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <label htmlFor="URL">آدرس صفحه فرود تبلیغ شما</label>
                            <input type="text" name="URL" id="URL" className="Campaign-Input mt-2" placeholder="URL"/>
                        </div>
                    </div>
                    <HorizontalDivider/>
                    <div className="row">
                        <div className="d-flex align-items-center mb-1">
                            <DotIndicator/>
                            <span>تنظیمات تبلیغ</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <h6 className="pt-4 pb-1">نوع محتوای تبلیغ</h6>
                            <Dropdown items={adTypeDropDownItems} placeHolder="انتخاب کنید"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <h6 className="pt-4 pb-1">عنوان تبلیغ</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: روز مادر"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <h6 className="pt-4 pb-1">وبسایت</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: google.com"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <h6 className="pt-4 pb-1">عنوان دکمه</h6>
                            <input type="text" name="" id="" className="Campaign-Input"
                                   placeholder="مثال: بیشتر بدانید"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <SingleSelectDropzone title={"آپلود ویدیو شما"}/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <SingleSelectDropzone title={"آپلود لوگوی برند"}/>
                        </div>
                    </div>
                    <div className="row pt-3">
                        <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                            <DotIndicator/>
                            <span>پیش نمایش تبلیغ شما</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-4 col-12">

                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-8 col-12">
                            <Matchingadtemplate type={1}/>
                        </div>
                    </div>
                </>
            );
        } else if (value === "G") {
            return (
                <>
                    <div className="mb-3">
                        <h6 className="mb-3 pt-3 font-light">جنسیت</h6>
                        <RadioButtons items={genderRadioContent} value={gender} setValue={setGender}/>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <h6 className="pt-4 pb-1">جستجوی دسته بندی</h6>
                            <Dropdown items={categoryDropDownItems} placeHolder="مثال: سلامت"/>
                        </div>
                    </div>
                    <HorizontalDivider/>
                    <div className="row">
                        <div className="d-flex align-items-center mb-1">
                            <DotIndicator/>
                            <span>تنظیمات تبلیغ</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <h6 className="pt-4 pb-1">نوع محتوای تبلیغ</h6>
                            <Dropdown items={adTypeDropDownItems} placeHolder="انتخاب کنید"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <h6 className="pt-4 pb-1">عنوان تبلیغ</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: روز مادر"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <h6 className="pt-4 pb-1">وبسایت</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: google.com"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <h6 className="pt-4 pb-1">عنوان دکمه</h6>
                            <input type="text" name="" id="" className="Campaign-Input"
                                   placeholder="مثال: بیشتر بدانید"/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <SingleSelectDropzone title={"آپلود ویدیو شما"}/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <SingleSelectDropzone title={"آپلود لوگوی برند"}/>
                        </div>
                    </div>
                    <HorizontalDivider/>
                </>
            );
        } else {
            return (
                <></>
            );
        }
    }
    return (
        <div className="Tab0">
            <div className="d-flex align-items-center mb-4">
                <DotIndicator/>
                <span>تنظیمات کلی</span>
            </div>
            <div className="col-12 mb-3">
                <h6 className="mb-3 pt-1 font-light">نوع مخاطب کمپین ویدیویی</h6>
                <RadioButtons items={typeRadioContent} value={type} setValue={setType}/>
            </div>
            {
                setRadioContent(type)
            }
        </div>
    );
}

export default Tab0;